/**
 * NavHistoryButtons
 *
 * @module components/Nav/NavHistoryButtons
 */

import PropTypes from 'prop-types';
import React from 'react';

import BackIcon from '../../../static/icons/ic_chevron_back.svg';
import ForwardIcon from '../../../static/icons/ic_chevron_forward.svg';
import * as ClientInfoUtils from '../../lib/ClientInfoUtils';
import { createBEM } from '../../lib/utils/css';
import Icon from '../Icon/Icon';

import './NavHistoryButtons.scss';

class NavHistoryButtons extends React.Component {
  static propTypes = {
    isBackgroundDark: PropTypes.bool,
  };

  onBackButtonClicked = () => {
    if (window.DesktopBridge) {
      window.DesktopBridge.goBack();
    }
  };

  onForwardButtonClicked = () => {
    if (window.DesktopBridge) {
      window.DesktopBridge.goForward();
    }
  };

  canGoBack = () => {
    if (window.DesktopBridge) {
      return window.DesktopBridge.canGoBack();
    }
    return true;
  };

  canGoForward = () => {
    if (window.DesktopBridge) {
      return window.DesktopBridge.canGoForward();
    }
    return true;
  };

  isDesktopBridgeSupported = () => {
    try {
      // try if these functions are available
      window.DesktopBridge.canGoForward();
      window.DesktopBridge.canGoBack();
      return true;
    } catch (e) {
      return false;
    }
  };

  render() {
    if (!ClientInfoUtils.isElectron() || !this.isDesktopBridgeSupported()) {
      return null;
    }

    const classes = createBEM('NavHistoryButtons', {
      dark: this.props.isBackgroundDark,
    });

    return (
      <div className={classes}>
        <button
          type='button'
          className='NavHistoryButtons__button NavHistoryButtons__backButton'
          onClick={this.onBackButtonClicked}
          disabled={!this.canGoBack()}
        >
          <Icon className='icon' glyph={BackIcon} />
        </button>
        <button
          type='button'
          className='NavHistoryButtons__button NavHistoryButtons__forwardButton'
          onClick={this.onForwardButtonClicked}
          disabled={!this.canGoForward()}
        >
          <Icon className='icon' glyph={ForwardIcon} />
        </button>
      </div>
    );
  }
}

export default NavHistoryButtons;
